import { footerData, siteInfo } from '@/mocks/home';

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto pt-16 pb-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="#hero" className="inline-block mb-4 no-underline">
              <span className="text-xl font-heading font-bold text-background-50">{siteInfo.name}</span>
            </a>
            <p className="text-background-400 text-sm leading-relaxed mb-4">
              {footerData.description}
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>

          {/* link groups */}
          {footerData.links.map((group, idx) => (
            <div key={idx}>
              <h3 className="font-heading font-semibold text-background-50 text-sm mb-4">{group.title}</h3>
              <ul className="space-y-2.5">
                {group.items.map((item, i) => (
                  <li key={i}>
                    <a href="#" className="text-background-400 hover:text-background-100 text-sm transition-colors cursor-pointer">{item}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* partners */}
        <div className="border-t border-background-700 pt-8 mb-8">
          <h3 className="font-heading font-semibold text-background-50 text-sm mb-4 text-center">合作伙伴</h3>
          <p className="text-background-500 text-xs text-center">更多合作伙伴即将加入</p>
        </div>

        {/* copyright */}
        <div className="border-t border-background-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-background-500 text-xs">
            &copy; {new Date().getFullYear()} {siteInfo.name} All Rights Reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-500 hover:text-background-200 text-xs transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="text-background-500 hover:text-background-200 text-xs transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-background-500 hover:text-background-200 text-xs transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}